import { render, staticRenderFns } from "./etl-table.vue?vue&type=template&id=92fc5a4a&scoped=true"
import script from "./etl-table.vue?vue&type=script&lang=ts"
export * from "./etl-table.vue?vue&type=script&lang=ts"
import style0 from "./etl-table.vue?vue&type=style&index=0&id=92fc5a4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fc5a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92fc5a4a')) {
      api.createRecord('92fc5a4a', component.options)
    } else {
      api.reload('92fc5a4a', component.options)
    }
    module.hot.accept("./etl-table.vue?vue&type=template&id=92fc5a4a&scoped=true", function () {
      api.rerender('92fc5a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/primary-kpi-step/summary/etl-lightbox/etl-table/etl-table.vue"
export default component.exports